import { ModalsContext, ModalType } from 'contexts/modal';
import { RealTimeServiceContext } from 'contexts/realTimeService';
import { useContext, useEffect, useRef } from 'react';

export const useReferralProgramNotifications = () => {
  const { referralProgram } = useContext(RealTimeServiceContext);
  const { handleModal, modals } = useContext(ModalsContext);

  const lastPayloadHash = useRef<string | null>(null);

  useEffect(() => {
    if (!referralProgram?.text || modals.length) return;

    const currentHash = JSON.stringify(referralProgram);

    if (currentHash === lastPayloadHash.current) {
      return;
    }

    lastPayloadHash.current = currentHash;

    handleModal(ModalType.ReferralProgram, { stayInSameWindow: true })();
  }, [handleModal, modals.length, referralProgram]);
};
